import React, {  useState } from "react";
import {
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { toast } from "react-toastify";
import apiClient from "../utils/apiClient";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const ChangePassword = ()=>{
    
  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [passwordErrors, setPasswordErrors] = useState({}); 
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const passwordValidation = (value) => {
    const regex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,}$/;
    return regex.test(value);
  };

 // ✅ Password Validation
 const validatePassword = () => {
    let tempErrors = {};
    if (!passwordData.oldPassword) tempErrors.oldPassword = "Old password is required";

    if (!passwordData.newPassword) {
        tempErrors.newPassword = "New password is required";
      } else if (!passwordValidation(passwordData.newPassword)) {
        tempErrors.newPassword =
          "Must be 8+ chars, include upper, lower, number & special char";
      }

    if (!passwordData.confirmPassword)
      tempErrors.confirmPassword = "Confirm password is required";

    if (
      passwordData.newPassword &&
      passwordData.confirmPassword &&
      passwordData.newPassword !== passwordData.confirmPassword
    ) {
      tempErrors.confirmPassword = "Passwords do not match";
    }

    setPasswordErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const toggleVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  // ✅ Handle Password Change
  const handleChangePassword = () => {
    if (!validatePassword()) return;

    apiClient
      .post("/api/vendor/change-password", passwordData)
      .then(() => {
        toast.success("Password updated successfully!");
        setPasswordData({ oldPassword: "", newPassword: "", confirmPassword: "" });
      })
      .catch((err) => toast.error(err.response?.data?.message || "Server error!"));
  };

    return <>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <TextField
        label="Old Password"
        type={showPassword.oldPassword ? "text" : "password"}
        value={passwordData.oldPassword}
        onChange={(e) =>
          setPasswordData({ ...passwordData, oldPassword: e.target.value })
        }
        fullWidth
        error={!!passwordErrors.oldPassword}
        helperText={passwordErrors.oldPassword}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => toggleVisibility("oldPassword")}>
                {showPassword.oldPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* New Password */}
      <TextField
        label="New Password"
        type={showPassword.newPassword ? "text" : "password"}
        value={passwordData.newPassword}
        onChange={(e) =>
          setPasswordData({ ...passwordData, newPassword: e.target.value })
        }
        fullWidth
        error={!!passwordErrors.newPassword}
        helperText={passwordErrors.newPassword}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => toggleVisibility("newPassword")}>
                {showPassword.newPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Confirm Password */}
      <TextField
        label="Confirm New Password"
        type={showPassword.confirmPassword ? "text" : "password"}
        value={passwordData.confirmPassword}
        onChange={(e) =>
          setPasswordData({
            ...passwordData,
            confirmPassword: e.target.value,
          })
        }
        fullWidth
        error={!!passwordErrors.confirmPassword}
        helperText={passwordErrors.confirmPassword}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => toggleVisibility("confirmPassword")}>
                {showPassword.confirmPassword ? (
                  <VisibilityOff />
                ) : (
                  <Visibility />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

              <Button
                variant="contained"
                onClick={handleChangePassword}
              >
                Change Password
              </Button>
            </Box>
    </>
}

export default ChangePassword